import EventDetailEvents from '@/screens/EventDetailEvents';

import useRootStore from '@/stores/useRootStore';

export default function PrivateTabsOrganizationMainEventsRoute() {
  const organizationId = useRootStore((state) => state.organizationId);

  return (
    <EventDetailEvents
      basePath="/organization/event/[eventId]"
      eventId={organizationId || ''}
    />
  );
}
